import { Component, Input, OnInit } from '@angular/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';

@Component({
  selector: 'app-colorpicker-cell',
  templateUrl: './colorpicker-cell.component.html',
  styleUrls: ['./colorpicker-cell.component.scss'],
})
export class ColorpickerCellComponent implements OnInit {
  @Input() public field!: ConstrainedField;
  //public static starterColor = "#2d819e";
  public static starterColor = null;
  public isOpen: boolean = false;

  public ngOnInit(): void {
    if (!this.field.control.value || (this.field.control.value as string).trim().length == 0) {
      this.field.control.setValue(ColorpickerCellComponent.starterColor);
    }
  }

  public onColorChange(color: string): void {
    this.field.control.setValue(color)
  }
}
